/**
 * @module お知らせ部共通コンポーネント
 */
export default {
  name: 'News',
  data() {
    return {};
  },
  props: {
    newsInfo: {
      type: Array,
      default: () => [
        // {
        //   id: 1,
        //   newsDateTime: {
        //     year: 2020,
        //     month: 2,
        //     day: 2,
        //     hour: 12,
        //     minutes: 0,
        //   }, //"2020年2月2日 12:00",
        //   newsTitle: "メンテナンスのお知らせ",
        //   newsContent:
        //     "サーバーメンテナンスのため一時的にアプリ利用ができなくなります。警備機器ホームアルソックXS をご利用のお客様は ALSOKホームページをご確認ください。",
        // },
        // {
        //   id: 2,
        //   newsDateTime: {
        //     year: 2020,
        //     month: 1,
        //     day: 1,
        //     hour: 8,
        //     minutes: 0,
        //   }, //"2020年2月2日 12:00",
        //   newsTitle: "バージョンアップのお知らせ",
        //   newsContent:
        //     "アプリバージョン ver2.0.3を公開予定です。古いアプリは利用できなくなります。",
        // },
      ],
      required: false,
    },
  },
};
